<template>
  <nav
    class="qmulus-breadcrumb"
  >
    <ol class="flex-row align-center">
      <template
        v-for="(item, index) of path"
        :key="index"
      >
        <li class="flex-row-union align-center">
          <slot
            name="item"
            :item="item"
          >
            <QmulusBreadcrumbItem :item="item" />
          </slot>
        </li>
        <li v-if="index < path.length - 1">
          <QmulusBreadcrumbItem :item="SEPARATOR" />
        </li>
      </template>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import QmulusBreadcrumbItem from './qmulus-breadcrumb-item.vue';
import {
  TBreadcrumbItem,
} from './qmulus-breadcrumb.ts';

/**
 * We use another QmulusBreadcrumbItem to enforce the same style (font-size, lineheight, etc).
 */
const SEPARATOR: TBreadcrumbItem = {
  icon: 'pi pi-chevron-right',
};

defineProps<{
  path: TBreadcrumbItem[],
}>();
</script>

<style scoped lang="scss">
.qmulus-breadcrumb {
  ol {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}
</style>
